"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamNameInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const zustandStore_1 = require("../../../../zustandStore");
const textInput_1 = __importDefault(require("../../../atoms/input/textInput"));
const useTeamNameInput_1 = require("./useTeamNameInput");
const TeamNameInput = () => {
    const { errors, changeTeamName } = (0, useTeamNameInput_1.useTeamNameInput)();
    const isTeamNameError = (0, zustandStore_1.useZustand)(state => state.team.isTeamNameError);
    const teamName = (0, zustandStore_1.useZustand)(state => state.team.teamName);
    return ((0, jsx_runtime_1.jsx)(textInput_1.default, { dataTestId: "teamName-input", className: "tst-team-name", onChange: changeTeamName, name: teamName, label: strings_1.teamInfoStrings.TEAM_NAME, placeholder: strings_1.teamInfoStrings.TEAM_NAME_PLACEHOLDER, value: teamName, singleError: false, errorMessage: isTeamNameError ? 'true' : '', infoMessages: errors[appConstants_1.teamSettingsErrorFields.teamName], fieldStyle: { width: '100%' } }));
};
exports.TeamNameInput = TeamNameInput;
